import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './BlockTitle.module.scss'

const BlockTitle = ({ title, size = 'large', background = 'red', DynamicTag = 'span' }) => (
  <DynamicTag styleName={classnames('heading', size, background)}>{title}</DynamicTag>
)

BlockTitle.propTypes = {
  title: PropTypes.string.isRequired,
  size: PropTypes.string,
  background: PropTypes.string,
  DynamicTag: PropTypes.string
}

export default BlockTitle



// WEBPACK FOOTER //
// ./src/components/BlockTitle/BlockTitle.js